<div class="d-flex justify-content-center align-content-center"
 		[class.legal-documents__container--mobile]="breakpointObserverService.screenSizeSubject.value === 'XSmall'">
	<mat-tab-group class="w-100" dynamicHeight selectedIndex="{{ indexTab }}">
		<mat-tab label="{{ tabsLink[0]['tab'] }}">
			<div class="legal-documents__tab-container">
				<h3 class="mat-h3" i18n="@@hub.legal-documents.cgu-title">CONDITIONS GÉNÉRALES D'UTILISATION</h3>
				<p class="mat-body">
					<span i18n="@@hub.legal-documents.cgu-subtitle-text-first">Retrouvez nos</span>&nbsp;<a
					class="legal-documents__cgu-url" [href]="cguUrl" target="_blank"><span
					i18n="@@hub.legal-documents.cgu-subtitle-text-second">conditions générales d'utilisation</span></a>
				</p>
			</div>
		</mat-tab>
		<mat-tab label="{{ tabsLink[1]['tab'] }}">
			<div class="legal-documents__tab-container">
				<h3 class="mat-h3" i18n="@@hub.legal-documents.legal-notice-title">MENTIONS LÉGALES</h3>
				<h4 class="mat-h4">PUBLICATION DU SITE</h4>
				<h5 class="mat-h5">Éditeur du site</h5>
				<p class="mat-body">
					Le site est édité par la société VISIATIV, Société anonyme à conseil d’administration, immatriculée
					au Registre du Commerce et des Sociétés de Lyon
					sous le numéro 395 008 246, au capital social de 2 736 914,40€, dont le siège social est situé au 26
					rue Benoît Bennier
					69260 Charbonnières-les-Bains, France. Numéro d'identification TVA de la société VISIATIV :
					FR00395008246.
					Numéro SIRET de la société VISIATIV : 39500824600013.
				</p>
				<h5 class="mat-h5">Directeur de publication</h5>
				<p class="mat-body">Monsieur Bertrand SICOT, en sa qualité de Directeur général délégué de la société VISIATIV.</p>
				<h5 class="mat-h5">Contact</h5>
				<ul>
					<li class="mat-body">Téléphone : +33 4 78 87 29 29</li>
					<li class="mat-body">Adresse mail : digital&#64;visiativ.com</li>
				</ul>
				<h4 class="mat-h4">HÉBERGEMENT DU SITE</h4>
				<h5 class="mat-h5">Hébergeur du site</h5>
				<p class="mat-body">
					Le site est hébergé par la société VISIATIV SOFTWARE, Société par actions simplifiées, immatriculée
					au Registre du Commerce et des Sociétés de Lyon
					sous le numéro 353 695 174, au capital social de 9 639 220,00€, dont le siège social est situé au 26
					rue Benoît Bennier
					69260 Charbonnières-les-Bains, France. Numéro d'identification TVA de la société VISIATIV SOFTWARE :
					FR12353695174.
					Numéro SIRET de la société VISIATIV SOFTWARE : 35369517400014.
				</p>
				<h5 class="mat-h5">Contact</h5>
				<p class="mat-body">Téléphone : +33 4 78 87 29 29</p>
				<h4 class="mat-h4">CONDITIONS GÉNÉRALES D'UTILISATION DU SITE</h4>
				<p class="mat-body">
					Consultez les Conditions Générales d’Utilisation VISIATIV accessibles sur le lien suivant :
					<a href="https://www.visiativ.com/documents-legaux/">https://www.visiativ.com/documents-legaux/</a>
				</p>
				<h4 class="mat-h4" >DONNÉES À CARACTÈRE PERSONNEL</h4>
				<iframe [src]="matomoIframeUrl"></iframe>
				<p class="mat-body">
					Consultez la Politique de protection des données personnelles VISIATIV accessible sur le lien
					suivant :
					<a href="https://www.visiativ.com/documents-legaux/ ">https://www.visiativ.com/documents-legaux/</a>
				</p>
				<h4 class="mat-h4">COOKIES</h4>
				<p class="mat-body">
					Consultez la Politique d’Utilisation des Cookies VISIATIV accessible sur le lien suivant :
					<a href="https://www.visiativ.com/documents-legaux/ ">https://www.visiativ.com/documents-legaux/</a>
				</p>
				<h4 class="mat-h4">LIMITATION DE RESPONSABILITÉS</h4>
				<p class="mat-body">
					VISIATIV ne sera en aucun cas responsable des dommages directs ou indirects résultant d’erreurs,
					d’une absence de disponibilité,
					de l'inexactitude et/ou incomplétude des informations diffusées sur le site, de la présence de virus
					sur le site et plus généralement
					de l’utilisation de ce dernier par l’utilisateur. VISIATIV décline toute responsabilité concernant
					le contenu des sites internet tierces
					et applications tierces vers lesquels le site peut rediriger via des liens hypertexte. L’utilisateur
					du site sera responsable de tout dommage
					résultant d’une utilisation du site non conforme aux Conditions Générales d’Utilisation, et plus
					généralement en cas d’agissements, de fautes,
					d’utilisations frauduleuses ou illicites du site, qu’il pourrait causer à VISIATIV ou aux tiers.
				</p>
				<h4 class="mat-h4">COPYRIGHT</h4>
				<p class="mat-body">
					Copyright © VISIATIV 2023 Siège social : 26 rue Benoît Bennier 69260 Charbonnières-les-Bains,
					France.
				</p>
			</div>
		</mat-tab>

		<mat-tab label="{{ tabsLink[2]['tab'] }}">
			<div class="legal-documents__tab-container">
				<h3 class="mat-h3" i18n="@@hub.legal-documents.privacy-policy-title">POLITIQUE DE CONFIDENTIALITÉ</h3>
				<p class="mat-body">
					<span i18n="@@hub.legal-documents.privacy-policy-subtitle-text-first">Retrouvez notre</span>&nbsp;<a [href]="confidentialPolicyUrl" target="_blank"><span
					i18n="@@hub.legal-documents.privacy-policy-subtitle-text-second">Politique de Gestion des Données Personnelles</span></a>
				</p>
			</div>
		</mat-tab>
	</mat-tab-group>
</div>
